/**
 * Journey phase enum.
 *
 * Kept in its own dependency-free module to stay immune to the `@lib/trip` ↔
 * `@lib/booking` import cycle: hosting it in `phases.ts` (which imports
 * `@lib/booking` before the enum is declared) let a cold bundler pass observe
 * `Phase` as `undefined` and never recover. A leaf module has nothing to wait
 * on, so the enum is ready the moment it is referenced.
 */
export enum Phase {
  BeforeJourney,
  BeforeOnlineCheckIn,
  BeforePresenceCheckIn,
  OnFirstDay,
  OnSecondDay,
  OnJourney,
  LastThreeDaysOfJourney,
  AfterJourney,
}
